import {ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {SpecLineModel} from "../../../properties/models/spec-line.model";
import {ClassificatorsQuery, ClassificatorValuesQuery, GLOBAL, PropertyQuery} from "common-shared";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-spec-value-view',
  templateUrl: './spec-value-view.component.html',
  styles: [
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpecValueViewComponent implements OnInit {
  @Input() spec: SpecLineModel;
  @Input() property: PropertyQuery;
  @Input() sourceId: string;
  @Input() showUnit = true;
  @HostBinding('class.text-gray-300') isInherited: boolean = false;
  @Output() edit = new EventEmitter<SpecLineModel>();

  propertyTypes = GLOBAL.Classificators.PropertyType;
  classificatorTypes = GLOBAL.Classificators.ClassificatorType;

  constructor(public classificatorValuesQuery: ClassificatorValuesQuery, public sanitizer: DomSanitizer, public classificatorsQuery: ClassificatorsQuery) { }

  ngOnInit(): void {
    this.isInherited = this.spec.LineSource?.Id == null || this.sourceId == null
      ? false
      : this.spec.LineSource.Id !== this.sourceId;
  }
}
